import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
const forWho = ['Hombres de 40 a 60 años con altas responsabilidades.', 'Profesionales que sienten que su cerebro es un proyector de cine que no se apaga de noche.', 'Padres de familia que necesitan recuperar su paciencia y claridad mental.', 'Hombres que han notado un aumento de peso o falta de libido debido al cansancio crónico.'];
const notForWho = ['Personas que buscan una "pastilla mágica" sin cambiar un solo hábito.', 'Quienes padecen apnea obstructiva del sueño clínica (requiere equipo médico).', 'Quienes no estén dispuestos a dejar el teléfono 60 minutos antes de dormir.'];
export function WhoItsFor() {
  return <section className="w-full bg-midnight py-24 px-6" data-id="element-227">
      <div className="max-w-6xl mx-auto" data-id="element-228">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-229">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-midnight-deep p-8 md:p-12 border-t-4 border-cyan-signal" data-id="element-230">
            <h3 className="font-display text-2xl md:text-3xl text-bone uppercase mb-8" data-id="element-231">
              Esto es para ti si...
            </h3>
            <ul className="space-y-6" data-id="element-232">
              {forWho.map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-233">
                  <div className="flex-shrink-0 mt-1" data-id="element-234">
                    <Check className="w-6 h-6 text-cyan-signal" data-id="element-235" />
                  </div>
                  <span className="text-steel text-lg leading-relaxed" data-id="element-236">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-midnight-deep p-8 md:p-12 border-t-4 border-alert" data-id="element-237">
            <h3 className="font-display text-2xl md:text-3xl text-bone uppercase mb-8" data-id="element-238">
              Esto NO es para ti si...
            </h3>
            <ul className="space-y-6" data-id="element-239">
              {notForWho.map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-240">
                  <div className="flex-shrink-0 mt-1" data-id="element-241">
                    <X className="w-6 h-6 text-alert" data-id="element-242" />
                  </div>
                  <span className="text-steel text-lg leading-relaxed" data-id="element-243">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}